import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { auth, db, functions } from '../config/firebase';
import { normalizarEmail } from './usuarios';

/**
 * Aceite de convite, agora por Cloud Function.
 *
 * O que mudou e por quê: antes o próprio navegador criava `usuarios/{uid}`, e a
 * regra do Firestore é que segurava tudo — ela tinha de conferir papel, e-mail e
 * prazo numa linguagem que não se testa de mesa. Hoje a regra apenas NEGA a
 * criação de perfil pelo navegador, e a decisão vive na função, com teste.
 *
 * Quem prova ser dono do endereço é o TOKEN que veio no link do convite, e que
 * só existe dentro do e-mail enviado para aquele endereço. Ele substitui a
 * verificação de e-mail do Firebase: a garantia é a mesma — controlar aquela
 * caixa — com uma etapa a menos e com a mensagem saindo do nosso domínio.
 */

export async function cadastrarComConvite(
  email: string,
  senha: string,
  nome: string,
  token: string,
): Promise<void> {
  const cred = await createUserWithEmailAndPassword(auth, normalizarEmail(email), senha);
  await updateProfile(cred.user, { displayName: nome.trim() });
  await aceitarConvite(token, nome);
}

export type SituacaoAceite = 'CRIADO' | 'JA_TINHA_PERFIL';

/**
 * Troca o token pelo perfil. Chamada logo depois do cadastro e também quando
 * alguém volta com a conta criada mas sem perfil — abandonar no meio do caminho
 * não pode deixar a pessoa presa do lado de fora.
 */
export async function aceitarConvite(token: string, nome?: string): Promise<SituacaoAceite> {
  const chamar = httpsCallable<{ token: string; nome?: string }, { situacao: SituacaoAceite }>(
    functions,
    'aceitarConvite',
  );
  const r = await chamar({ token, nome });
  return r.data.situacao;
}

export async function registrarAcesso(uid: string): Promise<void> {
  try {
    await updateDoc(doc(db, 'usuarios', uid), { ultimoAcesso: serverTimestamp() });
  } catch {
    // Registrar acesso nunca pode impedir alguém de usar o sistema.
  }
}
